import { render, staticRenderFns } from "./UnassignedOrderSearch.vue?vue&type=template&id=52e52449&scoped=true&"
import script from "./UnassignedOrderSearch.vue?vue&type=script&lang=js&"
export * from "./UnassignedOrderSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e52449",
  null
  
)

export default component.exports